module.exports = __webpack_public_path__ + "c85154b18a66eee8f284767f1e329aaf.pdf";